// extracted by mini-css-extract-plugin
module.exports = {"DropMenuItem":"DropMenuItem_DropMenuItem__3c46k"};